import { Map } from "immutable";
import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { InjectedFormProps } from "redux-form";
import { Field, reduxForm } from "redux-form/immutable";
import UpCustomerSettingsButtonFooter from "../../../../../components/UpCustomerSettingsButtonFooter";
import UpInputWithLabel from "../../../../../components/UpInputWithLabel";
import { multiSelectBoxNonImmutable } from "../../../../../components/up-styled-react-select";
import { selectBox } from "../../../../CustomerSettings/EmailSignature/input-fields";
import { IntegrationInfoList, IntegrationType } from "../../types";
import { Newsletter2GoListsSettings } from "./types";

type Newsletter2GoSettingsFormComponentProps = {
  saving: boolean;
  handleSave: (values: Newsletter2GoListsSettings) => void;
  listOptions: IntegrationInfoList[];
};

const Newsletter2GoSettingsFormComponent = (
  props: Newsletter2GoSettingsFormComponentProps &
    InjectedFormProps<Map<unknown, unknown>, Newsletter2GoSettingsFormComponentProps>
) => {
  const { pristine, invalid, handleSave, handleSubmit, reset, listOptions, saving } = props;

  const intl = useIntl();

  const options = useMemo(
    () => listOptions.map((l) => ({ label: l.name, value: l.id })),
    [listOptions]
  );

  return (
    <div>
      <Field
        name="list"
        component={selectBox}
        type="text"
        label={
          <FormattedMessage
            id={`containers.Integrations.newsletter2go.list.label`}
            defaultMessage="List to add new optins"
          />
        }
        placeholder={intl.formatMessage({
          id: `containers.Integrations.newsletter2go.list.placeholder`,
          defaultMessage: "Select List"
        })}
        infoText={intl.formatMessage(
          {
            id: `containers.Integrations.list.infoText`,
            defaultMessage:
              "After successfully connected to {integration} new optins will be added to this list. After the creation of a new list in the connected {integration} Account, please, delete this configuration line and re-connect again."
          },
          {
            integration: IntegrationType.NEWSLETTER_2_GO
          }
        )}
        width="100%"
        options={options}
      />

      <UpInputWithLabel label="Whitelist">
        <Field
          name="whitelist"
          component={multiSelectBoxNonImmutable}
          type="text"
          placeholder="Select Whitelist"
          width="100%"
          options={options}
        />
      </UpInputWithLabel>

      <UpCustomerSettingsButtonFooter
        saveButtonDisabled={pristine || invalid}
        resetButtonDisabled={pristine}
        saveButtonOnClick={handleSubmit((values) => handleSave(values.toJS()))}
        resetButtonOnClick={reset}
        saving={saving}
      />
    </div>
  );
};

export const Newsletter2GoSettingsForm = reduxForm<
  Map<unknown, unknown>,
  Newsletter2GoSettingsFormComponentProps
>({
  form: `IntegrationForm_newsletter2go`,
  enableReinitialize: true
})(Newsletter2GoSettingsFormComponent);
